<template>
<div id="salesmanList"  v-loading="exportLoading">
    <!-- 查询选项 -->
    <Form class="salesmanForm" :label-width="160">
      <FormItem class="form_item" :label="$t('businessType1')">
        <el-select clearable size="default" filterable v-model="businessType" :placeholder="$t('enter')">
          <el-option v-for="item in BusinessTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </FormItem>
      <FormItem class="form_item" :label="$t('salesRegion1')">
        <el-select v-model="salesRegion" filterable clearable :placeholder="$t('enter')">
          <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
        </el-select>
      </FormItem>
      <FormItem class="form_item" :label="$t('projectManager1')">
        <el-select v-model="projectManager" clearable filterable remote :remote-method="value => remoteMethod('ProjectManagerSeachList', value)"
            :placeholder="$t('select')">
          <el-option v-for="(item, index) in ProjectManagerSeachList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
        </el-select>
      </FormItem>
      <FormItem class="form_item" :label="$t('serviceDeliveryCountry')" prop="serviceDeliveryCountry">
        <el-select v-model="serviceDeliveryCountry" filterable clearable :placeholder="$t('enter')">
          <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
        </el-select>
      </FormItem>
      <FormItem class="form_item" :label="$t('industry')" prop="industry">
        <el-select v-model="industry" filterable clearable :placeholder="$t('enter')">
          <el-option v-for="item in IndustryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
        </el-select>
      </FormItem>
      <div class="buttonDiv">
        <el-button type="primary" size="mini" icon="el-icon-search" @click="searchManagerList">{{$t('search')}}</el-button>
        <el-button v-has="{class:'projectExport'}" type="primary" size="mini" @click="exportExcel">{{$t('export')}}</el-button>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addManager">{{$t('add')}}</el-button>
      </div>
    </Form>
     <div class="contentTableDiv">
         <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="id" v-if="false"></el-table-column>
            <el-table-column prop="originType" :label="$t('origin')" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="businessType" :label="$t('businessType')" align="center"></el-table-column>
            <el-table-column prop="salesRegion" :label="$t('salesRegion')" align="center"></el-table-column>
            <el-table-column prop="serviceDeliveryCountry" :label="$t('serviceDeliveryCountry')" align="center"></el-table-column>
            <el-table-column prop="industry" :label="$t('industry')" align="center"></el-table-column>
            <el-table-column prop="salesDepartmentName" :label="$t('salesDepartment')" align="center"></el-table-column>
            <el-table-column prop="serviceDepartmentName" :label="$t('serviceDepartment')" align="center"></el-table-column>
            <el-table-column prop="projectManagerName" :label="$t('projectManager')" align="center"></el-table-column>
            <el-table-column prop="groupIdName" :label="$t('groupName')" align="center"></el-table-column>
            <el-table-column :label="$t('operate')" align="center" fixed="right"  width="200">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">{{$t('delete')}}</el-button>
             </template>
          </el-table-column>
        </el-table> 
    </div>
    <div class="pageDiv">
      <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pageSize"
         layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <!--新增-->
    <Modal v-model="modelAdd" :closable='false' :mask-closable='false' :title="$t('addManager')">
      <div slot="footer">
        <Button type="primary" size="small" @click="cancel">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="add">{{$t('confrim')}}</Button>
      </div>
      <Form  ref="addManagerForm"  :label-width="150">
        <FormItem :label="$t('origin')" prop="postDes">
          <el-select v-model="addManagerForm.originType" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in OriginList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('businessType')" prop="postDes">
          <el-select filterable v-model="addManagerForm.businessType" clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in BusinessTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('salesRegion')" prop="postDes">
          <el-select v-model="addManagerForm.salesRegion" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('serviceDeliveryCountry')" prop="postDes">
          <el-select v-model="addManagerForm.serviceDeliveryCountry" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('industry')" prop="postDes">
          <el-select v-model="addManagerForm.industry" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in IndustryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('salesDepartment')" prop="postDes">
          <el-select v-model="addManagerForm.salesDepartment" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in SalesDepartmentList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('serviceDepartment')" prop="postDes">
          <el-select v-model="addManagerForm.serviceDepartment" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in ServiceDepartmentList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('projectManager')" prop="postDes">
          <el-select v-model="addManagerForm.projectManager" clearable filterable remote :remote-method="value => remoteMethod('ProjectManagerList', value)"
              :placeholder="$t('select')"  style="width:200px">
            <el-option v-for="(item, index) in ProjectManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('groupName')" prop="postDes">
          <el-select v-model="addManagerForm.groupId" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in GroupNameList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
      </Form>
    </Modal>
    <!--修改--> 
    <Modal v-model="modelUpdate" :closable='false' :mask-closable='false' :title="$t('updateManagerInfo')">
      <div slot="footer">
        <Button type="primary" size="small" @click="cancel">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="ok">{{$t('confrim')}}</Button>
      </div>
      <Form ref="updateManagerForm"  :label-width="150" >
        <FormItem :label="$t('origin')" prop="postDes">
          <el-select v-model="updateManagerForm.originType" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in OriginList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('businessType')" prop="postDes">
          <el-select v-model="updateManagerForm.businessType" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in BusinessTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('salesRegion')" prop="postDes">
          <el-select v-model="updateManagerForm.salesRegion" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('serviceDeliveryCountry')" prop="postDes">
          <el-select v-model="updateManagerForm.serviceDeliveryCountry" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('industry')" prop="postDes">
          <el-select v-model="updateManagerForm.industry" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in IndustryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('salesDepartment')" prop="postDes">
          <el-select v-model="updateManagerForm.salesDepartment" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in SalesDepartmentList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('serviceDepartment')" prop="postDes">
          <el-select v-model="updateManagerForm.serviceDepartment" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in ServiceDepartmentList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('projectManager')" prop="postDes">
          <el-select v-model="updateManagerForm.projectManager" clearable filterable remote :remote-method="value => remoteMethod('ProjectManagerList', value)"
             :placeholder="$t('select')"  style="width:200px">
            <el-option v-for="(item, index) in ProjectManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('groupName')" prop="postDes">
          <el-select v-model="updateManagerForm.groupId" filterable clearable :placeholder="$t('enter')" style="width:200px">
            <el-option v-for="item in GroupNameList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
    import * as validate from '@/utils/validate'

    export default {
        name: 'manager',
        created () {
          this.getManagerList(); //获取组列表
          this.getCountry(); //获取国家
          this.getIndustryList();
          this.getDeptList();
          this.getDataList('originType');
          this.getDataList('businessType');
          this.getDataList('groupId');
        },
        data () {
            return {
              originType: null,
              businessType : null,
              salesRegion : null,
              serviceDeliveryCountry : null,
              industry : null,
              salesDepartment : null,
              serviceDepartment : null,
              projectManager : null,
              groupId:null,
              currentPage: 1,
              totalCount: 0,
              pageSize: 10,
              tableData: [],
              addManagerForm:{
                originType: null,
                businessType: null,
                salesRegion: null,
                serviceDeliveryCountry: null,
                industry: null,
                salesDepartment: null,
                serviceDepartment: null,
                projectManager: null,
                groupId: null,
              },
              modelAdd: false,
              updateManagerForm:{
                originType: null,
                businessType: null,
                salesRegion: null,
                serviceDeliveryCountry: null,
                industry: null,
                salesDepartment: null,
                serviceDepartment: null,
                projectManager: null,
                groupId: null,
              },
              modelUpdate:false,           
              treeExpandedKeys:[],//展开项
              // OriginList:[
              //   { value: 'test1',label: 'test1'},
              //   { value: '22',label: '22'},
              //   { value: 'origin_type2',label: 'origin_type2'},
              // ],
              // BusinessTypeList:[
              //   { value: 'BR',label: 'BR'},
              //   { value: 'RO',label: 'RO'},
              //   { value: 'NEC',label: 'NEC'},
              //   { value: 'SBR',label: 'SBR'},
              //   { value: 'SRO',label: 'SRO'},
              //   { value: 'SNEC',label: 'SNEC'},
              // ],
              // GroupNameList:[
              //   { value: 'name1',label: 'name1'},
              //   { value: 'name2',label: 'name2'},
              //   { value: 'name3',label: 'name3'},
              // ],
              OriginList: [],
              BusinessTypeList: [],
              GroupNameList: [],
              CountryList: [],
              IndustryList: [],
              SalesDepartmentList: [],
              ServiceDepartmentList: [],
              ProjectManagerList: [],
              ProjectManagerSeachList: [],
              rangeNumber: 10,
              exportLoading: false,
            }
        },
        methods: {
            getDataList(value){
              let url =`${this.$store.state.islhurl}projectManager/selectDataByType?type=`+value;
              this._get(url).then(
                res => {   
                  if(value === 'originType'){
                    this.OriginList = res.data
                  }else if(value === 'businessType'){
                    this.BusinessTypeList = res.data
                  }else if(value === 'groupId'){
                    this.GroupNameList = res.data
                  }else{}
                }
              )
            },
            getCountry(){
              let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
              let pm = {
                sysKey: 'Country',
                delFlg: '0',
              }
              this._post(url,pm).then(
                res => {   
                  this.CountryList = res.data;
                }
              )
            },
            getIndustryList(){
              let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
              let pm = {
                sysKey: 'Industry',
              }
              this._post(url,pm).then(
                res => {   
                  this.IndustryList = res.data;
                }
              )
            },
            getDeptList(){
              let url =`${this.$store.state.islhurl}dept/getSelectData`;
              let pm = {
                deptCodechain: 'SelectDept',
              }
              this._post(url,pm).then(
                res => {   
                  this.SalesDepartmentList = res.data;
                  this.ServiceDepartmentList = res.data;
                }
              )
            },
            // loadMore(n) {
            //   // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
            //   // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
            //   return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数,可自定义
            // },
            //远程搜索方法
            remoteMethod(list, query) {
              if (query !== '') {
                // 清除之前的定时器
                if (this.timeout) {
                  clearTimeout(this.timeout)
                }
                // 防抖处理，300ms后执行
                this.timeout = setTimeout(() => {
                  this.fetchUserOptions(list, query)
                }, 200)
              } else {
                this[list] = [];
              }
            },
            fetchUserOptions(list, query) {
              let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
              this._get(url).then().then(res => {
                if(res.code === 200 && res.data) {
                  this[list] = res.data;
                } else {
                  this[list] = [];
                }
              }).catch(error => {
                this[list] = [];
                console.error('搜索失败:', error)
              })
            },
            getManagerList(){
              let url = `${this.$store.state.islhurl}projectManager/getList/${this.pageSize}/${this.currentPage}`
              let pm = {
                sysValue: this.groupId, 
                delStatus: 0, 
                islhToken: sessionStorage.getItem('islhtoken'),
              }
              this._post(url,pm).then(
                res =>{
                  console.log(res);
                  this.tableData =res.data.records
                  this.totalCount = res.data.total
                }
              )
            },
            searchManagerList(){
              this.pageSize = 10;
              this.currentPage = 1;
              let url = `${this.$store.state.islhurl}projectManager/getList/${this.pageSize}/${this.currentPage}`
              let pm = {
                businessType: this.businessType &&  this.businessType !== ''? this.businessType:null,
                salesRegion: this.salesRegion && this.salesRegion !==''?this.salesRegion:null,
                projectManager: this.projectManager,
                serviceDeliveryCountry: this.serviceDeliveryCountry!==''?this.serviceDeliveryCountry:null,
                industry: this.industry!==''?this.industry:null,
                islhToken: sessionStorage.getItem('islhtoken'),
                // sysValue: this.groupName, 
                // delStatus: 0, 
              }
              this._post(url,pm).then(
                res =>{
                  this.tableData = res.data.records
                  this.totalCount = res.data.total
                }
              )
            },
            addManager(){
              this.addManagerForm = {}
              this.modelAdd = true
            },
            add(){
              if(!this.addManagerForm.originType || this.addManagerForm.originType === null || this.addManagerForm.originType === ''){
                var msg = this.$t('originNull');
                this.$Message.error(msg);
                return;
              }
              // if(this.addManagerForm.businessType === null || this.addManagerForm.businessType === ''){
              //   var msg = this.$t('businessTypeNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              // if(this.addManagerForm.salesRegion === null || this.addManagerForm.salesRegion === ''){
              //   var msg = this.$t('salesRegionNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              // if(this.addManagerForm.serviceDeliveryCountry === null || this.addManagerForm.serviceDeliveryCountry === ''){
              //   var msg = this.$t('serviceDeliveryCountryNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              // if(this.addManagerForm.industry === null || this.addManagerForm.industry === ''){
              //   var msg = this.$t('industryNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              // if(this.addManagerForm.salesDepartment === null || this.addManagerForm.salesDepartment === ''){
              //   var msg = this.$t('salesDepartmentNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              if(!this.addManagerForm.serviceDepartment || this.addManagerForm.serviceDepartment === null || this.addManagerForm.serviceDepartment === ''){
                var msg = this.$t('serviceDepartmentNull');
                this.$Message.error(msg);
                return;
              }
              if(!this.addManagerForm.projectManager || this.addManagerForm.projectManager === null || this.addManagerForm.projectManager === ''){
                var msg = this.$t('projectManagerNull');
                this.$Message.error(msg);
                return;
              }
              if(!this.addManagerForm.groupId || this.addManagerForm.groupId === null || this.addManagerForm.groupId === ''){
                var msg = this.$t('groupNameNull');
                this.$Message.error(msg);
                return;
              }
              let params = {
                originType: this.addManagerForm.originType,
                businessType : this.addManagerForm.businessType,
                salesRegion : this.addManagerForm.salesRegion,
                serviceDeliveryCountry : this.addManagerForm.serviceDeliveryCountry,
                industry : this.addManagerForm.industry,
                salesDepartment: this.addManagerForm.salesDepartment,
                serviceDepartment: this.addManagerForm.serviceDepartment,
                projectManager : this.addManagerForm.projectManager,
                groupId : this.addManagerForm.groupId,
                islhToken: sessionStorage.getItem('islhtoken'),
              }
              let url = `${this.$store.state.islhurl}projectManager/insert`
              this._post(url,params).then(
                res => {
                  if(res.code == '200'){
                    this.modelAdd = false;
                    this.getManagerList()
                    var msg = this.$t('saveSus');
                    this.$Message.success(msg);
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res.message,
                    });
                  }
                }
              )
              
            },
            handleEdit(index) {
              this.id = index.id
              this.updateManagerForm.originType = index.originType
              this.updateManagerForm.businessType = index.businessType
              this.updateManagerForm.salesRegion = index.salesRegion
              this.updateManagerForm.serviceDeliveryCountry = index.serviceDeliveryCountry
              this.updateManagerForm.industry = index.industry
              this.updateManagerForm.salesDepartment = index.salesDepartment
              this.updateManagerForm.serviceDepartment = index.serviceDepartment
              this.updateManagerForm.projectManager = index.projectManager
              this.updateManagerForm.groupId = index.groupId
              this.modelUpdate = true;
            },
            //修改Group信息确认
            ok(){
              if(!this.updateManagerForm.originType || this.updateManagerForm.originType === null || this.updateManagerForm.originType === ''){
                var msg = this.$t('originNull');
                this.$Message.error(msg);
                return;
              }
              // if(this.updateManagerForm.businessType === null || this.updateManagerForm.businessType === ''){
              //   var msg = this.$t('businessTypeNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              // if(this.updateManagerForm.salesRegion === null || this.updateManagerForm.salesRegion === ''){
              //   var msg = this.$t('salesRegionNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              // if(this.updateManagerForm.serviceDeliveryCountry === null || this.updateManagerForm.serviceDeliveryCountry === ''){
              //   var msg = this.$t('serviceDeliveryCountryNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              // if(this.updateManagerForm.industry === null || this.updateManagerForm.industry === ''){
              //   var msg = this.$t('industryNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              // if(this.updateManagerForm.salesDepartment === null || this.updateManagerForm.salesDepartment === ''){
              //   var msg = this.$t('salesDepartmentNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              if(!this.updateManagerForm.serviceDepartment || this.updateManagerForm.serviceDepartment === null || this.updateManagerForm.serviceDepartment === ''){
                var msg = this.$t('serviceDepartmentNull');
                this.$Message.error(msg);
                return;
              }
              if(!this.updateManagerForm.projectManager || this.updateManagerForm.projectManager === null || this.updateManagerForm.projectManager === ''){
                var msg = this.$t('projectManagerNull');
                this.$Message.error(msg);
                return;
              }
              if(!this.updateManagerForm.groupId || this.updateManagerForm.groupId === null || this.updateManagerForm.groupId === ''){
                var msg = this.$t('groupNameNull');
                this.$Message.error(msg);
                return;
              }
              let params = {
                id: this.id,
                originType: this.updateManagerForm.originType,
                businessType : this.updateManagerForm.businessType,
                salesRegion : this.updateManagerForm.salesRegion,
                serviceDeliveryCountry : this.updateManagerForm.serviceDeliveryCountry,
                industry : this.updateManagerForm.industry,
                salesDepartment : this.updateManagerForm.salesDepartment,
                serviceDepartment : this.updateManagerForm.serviceDepartment,
                projectManager : this.updateManagerForm.projectManager,
                groupId : this.updateManagerForm.groupId,
                islhToken: sessionStorage.getItem('islhtoken'),
              }
              let url = `${this.$store.state.islhurl}projectManager/edit`
              this._post(url,params).then(
                res => {
                  if(res.code == '200'){
                    this.modelUpdate = false;
                    this.getManagerList();
                    var msg = this.$t('modifySus');
                    this.$Message.success(msg);
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res.message,
                    });
                  }
                 
                }
              )   
            },
            //删除组
            handleDelete(index){
              var msg1 = this.$t('delMsg');
              var msg2 = this.$t('warnMsg');
              var msg3 = this.$t('confrim');
              var msg4 = this.$t('cancle');
              this.$confirm(msg1, msg2, {
                confirmButtonText: msg3,
                cancelButtonText: msg4,
                type: 'warning'
              }).then(() => {
                let url = `${this.$store.state.islhurl}projectManager/deleteById?id=${index.id}`
                this._post(url).then(
                  res =>{
                    var msg = this.$t('delSus');
                    this.$Message.success(msg);
                    this.getManagerList();
                  }
                )
              }).catch(() => {
              }); 
            },

            cancel(){
              this.modelAdd = false;
              this.modelUpdate = false;
            },
            // 分页
            changePage (val) {
              this.currentPage = val
              this.getManagerList();
            },
            // 改变当前页显示条数
            changePageSize (val) {
              this.pageSize = val
              this.getManagerList();
            },
            handleSelectionChange(val) {
              this.multipleSelection = val;
            },
            exportExcel(){
              this.exportLoading = true;
              let execlName = 'Manager'+new Date().getTime()+'.xlsx';
              const length = this.multipleSelection?this.multipleSelection.length:null;
              let ids = [];
              if(length && length !==0){
                for (let i = 0; i < length; i++) {
                  ids.push(this.multipleSelection[i].id)
                }
              }
              this.$axios({
                url: `${this.$store.state.islhurl}projectManager/exportInfo`,
                method: 'post',
                data: {
                  ids: ids,
                  originType: this.originType==''?null:this.originType,
                  businessType : this.businessType==''?null:this.businessType,
                  salesRegion : this.salesRegion==''?null:this.salesRegion,
                  serviceDeliveryCountry : this.serviceDeliveryCountry==''?null:this.serviceDeliveryCountry,
                  industry : this.industry==''?null:this.industry,
                  salesDepartment : this.salesDepartment==''?null:this.salesDepartment,
                  serviceDepartment : this.serviceDepartment==''?null:this.serviceDepartment,
                  projectManager : this.projectManager==''?null:this.projectManager,
                  groupId : this.groupId==''?null:this.groupId,
                  islhToken: sessionStorage.getItem('islhtoken'),
                },
                responseType:"blob"
              }).then(response=>{
                this.exportLoading = false;
                const blob = new Blob([response.data])
                const aEle = document.createElement('a');     // 创建a标签
                const href = window.URL.createObjectURL(blob);       // 创建下载的链接
                aEle.href = href;
                aEle.download = execlName;  // 下载后文件名
                document.body.appendChild(aEle);
                aEle.click();     // 点击下载 
                document.body.removeChild(aEle); // 下载完成移除元素
                window.URL.revokeObjectURL(href) // 释放掉blob对象
              })
            },
        },
        directives:{
          'el-select-loadmore':(el, binding) => {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            if(SELECTWRAP_DOM){
              //解除绑定事件
              el.unbindEventListener = () => {
                SELECTWRAP_DOM.removeEventListener("scroll", function () {
                  const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                  if (condition) binding.value();
                });
              }
              //绑定事件
              SELECTWRAP_DOM.addEventListener("scroll", function () {
                /**
                 * scrollHeight 获取元素内容高度(只读)
                 * scrollTop 获取或者设置元素的偏移值,
                 *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                 * clientHeight 读取元素的可见高度(只读)
                 * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                 * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                 */
                const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (condition) binding.value();
              });
            }
          },
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/manager/managerInfo.vue